<template>
    <b-modal v-model="visible" :modal-class="modalClass" :class="[options.modalClass]" hide-footer v-bind:title="title">
        <p>{{message}}</p>
        <div class="modal-footer">
            <b-button type="button" @click="onCancel" :variant="options.btnNoVariant">{{options.btnNo}}</b-button>     
            <b-button type="submit" @click="onSubmit" :variant="options.btnYesVariant">{{options.btnYes}}</b-button> 
        </div>       
    </b-modal>
</template>

<script>
    export default {
        data: function () {
            return {
                message: '',
                title :'',
                success: null,
                cancel: null,
                modalClass: 'bs-modal-confirm colored-header',
                options: {
                    btnYes: 'Ok',
                    btnNo: 'Abbrechen',
                    btnYesVariant: 'primary',
                    btnNoVariant: 'light',
                    modalClass:''
                },
                visible: false,
                value: ''
            };
        },
        methods: {
            show: function (message, title, options = {}, success = null, cancel = null) {             
                this.title = title;
                this.message = message;
                this.success = success;
                this.cancel = cancel;
                this.options = {...this.options, ...options};
                this.modalClass = this.modalClass + ' '+this.options.modalClass;
                this.visible = true;
            },
            onSubmit: function (event) {
                event.preventDefault();
                this.visible = false;
                if (this.success) {
                    this.success();
                }
            },
            onCancel: function (event) {
                event.preventDefault();
                this.visible = false;
                if (this.cancel) {
                    this.cancel();
                }
            }
        }
    }
</script>

<style lang="scss">
    .bs-modal-confirm{
      .modal-footer{
        padding-bottom: 0;
        margin: 1rem -1rem 0 -1rem;
      }
    }
</style> 